<!-- Tasks Header -->
<mat-toolbar color="accent">
  <div role="heading" class="mat-title">Tasks</div>
  <div class="spacer"></div>
  <!-- Tasks List Actions -->
  <div role="toolbar">
    <button mat-raised-button id="tasks-add" (click)="addTask()">
      <mat-icon>add_task</mat-icon> New Task
    </button>
    <button mat-raised-button id="tasks-clear" (click)="clearDone()">
      <mat-icon>delete_sweep</mat-icon> Clear Done
    </button>
    <app-tasks-filter-button></app-tasks-filter-button>
  </div>
</mat-toolbar>
<!-- Tasks List -->
<mat-list cdkDropList id="tasks-list" (cdkDropListDropped)="drop($event)" [cdkDropListData]="roots$|async" [cdkDropListConnectedTo]="['subtasks-list']">
  <app-tasks-item cdkDrag *ngFor="let task of roots$ | async; index as i" [tabindex]="i" [cdkDragData]="task" [task]="task" (click)="onSelect(task)" (deleted)="onDeleted(task)" (undeleted)="onUndeleted(task)" (completed)="onCompleted(task)">
  </app-tasks-item>
</mat-list>
